import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { QuestionLibrary } from '@/features/staff-workspace/QuestionLibrary';

export const Route = createFileRoute('/admin/library')({
  component: AdminLibraryPage,
});

function AdminLibraryPage() {
  const allowed = useCan('content.admin');
  if (!allowed) {
    return (
      <StaffOnly title="You cannot open the library" description="Ask an admin for staff access." />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Question library"
        description="Every question in your skills, how students are doing on it, and its history. Editing a live question makes a new draft; the live version stays until a different person approves the change."
      />
      <QuestionLibrary />
    </div>
  );
}
